<template lang='pug'>
  v-row(justify='center')
    v-col(cols='12' md='10' lg='8' xl='8')
      slot
</template>

<script>
export default {
  name: 'WebsiteSpacing'
};
</script>

<style scoped>

</style>
